import { Step, useMenu } from '../../../contexts/MenuContext'
import { Container } from './styles'
import { PlanButton } from '../../molecules/PlanButton'
import { PlanDescription } from '../../molecules/PlanDescription'
import { PlanPrice } from '../../molecules/PlanPrice'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'

export function Plan( { activeBox, categorySelected, color, handlePlanClick, isSelected, planObject, gifts } ) {
  const { goToNextStep, activeStep } = useMenu()

  const handlePlanButtonClick = () => {
    if ( activeStep < Step.PERSONAL ) {
      goToNextStep( { 'activeStep': Step.CHOOSE_BOX } )
    }
  }

  const handleContainerClick = () => {
    handlePlanClick( planObject )
  }

  const getYearlyPercentageDiscountText = () => categorySelected === 2 ? 'Recomendado | 15% OFF' : 'Recomendado | 13% OFF'

  return (
    <Container
      color={ color }
      isSelected={ isSelected }
      onClick={ handleContainerClick }
    >
      {activeBox && (
        <Typography
          color="branco"
          fontWeight="l"
          variant="helperText"
        >
          { getYearlyPercentageDiscountText() }
        </Typography>
      )}
      <PlanDescription
        categorySelected={ categorySelected }
        titlePlan={ planObject.tipo_plano }
        valueSaved={ planObject.valorEconomizado }
        gifts={ gifts }
      />
      <PlanPrice valueKit={ planObject.valor_por_kit } />
      <PlanButton
        categorySelected={ categorySelected }
        color={ color }
        handlePlanClick={ handlePlanButtonClick }
        planId={ planObject.id }
        titlePlan={ `Quero plano ${planObject.tipo_plano.toLowerCase()}` }
      />
    </Container>
  )
}

Plan.propTypes = {
  'activeBox': PropTypes.bool.isRequired,
  'categorySelected': PropTypes.number.isRequired,
  'color': PropTypes.string.isRequired,
  'handlePlanClick': PropTypes.func.isRequired,
  'isSelected': PropTypes.bool.isRequired,
  'planObject': PropTypes.object.isRequired,
}
